import React from "react";
import { useSelector } from "react-redux";
import favLogo from "assets/logo/fav_v3.png";
import favLogo104 from "assets/images/Favorites_104.png";
import { getLocalStorageValue } from "config/helper";
const WishList = () => {
  const clientId = getLocalStorageValue("RSAclient-id");
  const cartWishlistDetails = useSelector(({ cartWishlist }) => cartWishlist);
  const allow_ecommerce = useSelector(({ common }) => common.commonDetailsData.ecom_section.allow_ecommerce);
  const favoriteListImageLogo = useSelector(({ common }) => common.commonDetailsData.header_section.favorite_list_image);
  return (
    <>
      {cartWishlistDetails && allow_ecommerce == "1" && (
        <div className="wish-list info-wrapper" >
          <div className="add-to-list-icon">
            {/* <img

                  src={clientId === "104" ? favLogo104 : favoriteListImageLogo}
                  alt="Favotites"
                  style={{ height: "24px", width: "30px" }}
                /> */}
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="36px" viewBox="0 0 24 24"><path fill="currentColor" d="M2 19.004h2.004V17H2zM7 19h15v-2H7zm-5-5.996h2.004V11H2zM7 13h15v-2H7zM2 7.004h2.004V5H2zM7 7h15V5H7z" /></svg> */}
           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 256 256"><path fill="currentColor" d="M32 64a8 8 0 0 1 8-8h176a8 8 0 0 1 0 16H40a8 8 0 0 1-8-8m8 72h64a8 8 0 0 0 0-16H40a8 8 0 0 0 0 16m80 48H40a8 8 0 0 0 0 16h80a8 8 0 0 0 0-16m128-40c0 36.52-50.28 62.08-52.42 63.16a8 8 0 0 1-7.16 0C186.28 206.08 136 180.52 136 144a32 32 0 0 1 56-21.14A32 32 0 0 1 248 144m-16 0a16 16 0 0 0-32 0a8 8 0 0 1-16 0a16 16 0 0 0-32 0c0 20.18 26.21 39.14 40 46.93c13.79-7.78 40-26.74 40-46.93"/></svg>
            {cartWishlistDetails.wishlistItemsCount !== "0" ? (
              <div>
                <span>{cartWishlistDetails.wishlistItemsCount} </span>
              </div>
            ) : (
              ""
            )}
          </div>
          <div>
            <p>Lists</p>
          </div>
        </div>
      )}
    </>
  );
};

export default WishList;
